/* eslint-disable */
// @ts-nocheck

import { useContext, useState } from 'react'
import Barcode from 'react-barcode'
import { SubmitHandler, useForm } from 'react-hook-form'
import { CiBarcode } from 'react-icons/ci'

import useServer from '../../../api/useServerMain'
import AsyncComboBox from '../../../components/forms/AsyncCombobox'
import DateInput from '../../../components/forms/DateInput'
import Input from '../../../components/forms/Input'
import Select from '../../../components/forms/Select'
import TextArea from '../../../components/forms/TextArea'
import Toggle from '../../../components/forms/Toggle'
import Button from '../../../components/misc/Button'
import Modal from '../../../components/misc/GenericModal'
import { BasicType, SelectInterface } from '../../../interfaces/InterfacesLocal'
import { EditClientCtx } from './EditOnlineClientContainer'

const EditOnlinePersonalData = () => {
  const { denyRoles } = useServer()
  const { handleSubmit, control } = useForm()
  const { client, editClient, isLoading } = useContext(EditClientCtx)

  const [barCode, setBarCode] = useState<string | null>(null)

  const sexSelect: SelectInterface[] = [
    {
      id: 'male',
      name: 'Masculino',
    },
    {
      id: 'female',
      name: 'Femenino',
    },
    {
      id: 'other',
      name: 'Otro',
    },
  ]

  const generateBarCode = () => {
    const code = '(01)' + client!.barCode?.padStart(8, '0')
    setBarCode(code)
  }

  const onSubmit: SubmitHandler<BasicType> = (data) => {
    const dataToSend = data
    if (data.barCode === client?.barCode) {
      delete dataToSend.barCode
    }

    editClient && editClient(client?.id, dataToSend)
  }

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex h-96 flex-col gap-3 overflow-scroll px-1 pr-3 scrollbar-thin scrollbar-thumb-gray-300">
          <Input
            label="Nombre"
            name="firstName"
            control={control}
            // rules={{ required: "Campo requerido" }}
            defaultValue={client?.firstName}
          />
          <Input
            label="Apellidos"
            name="lastName"
            control={control}
            // rules={{ required: "Campo requerido" }}
            defaultValue={client?.lastName}
          />

          <div className="relative">
            <Input
              control={control}
              defaultValue={client?.barCode}
              label="Código de barra"
              name="barCode"
              textAsNumber
              // disabled={!adminRole}
            />
            {client?.barCode && (
              <CiBarcode
                className="absolute bottom-0.5 right-2 text-4xl text-gray-600 hover:scale-105 hover:cursor-pointer hover:text-gray-700"
                onClick={generateBarCode}
              />
            )}
          </div>

          <Input
            control={control}
            defaultValue={client?.ci}
            label="No. de identificación"
            name="ci"
          />
          <Select
            control={control}
            data={sexSelect}
            defaultValue={client?.sex}
            label="Sexo"
            name="sex"
          />
          <AsyncComboBox
            control={control}
            dataQuery={{
              url: '/customer/categories/customer',
              defaultParams: { all_data: false },
            }}
            label="Categoría"
            name="customerCategoryId"
            normalizeData={{ id: 'id', name: 'name' }}
          />
          <DateInput
            control={control}
            defaultValue={client?.birthAt}
            label="Fecha de nacimiento"
            name="birthAt"
            untilToday
          />
          <TextArea
            control={control}
            defaultValue={client?.legalNotes}
            label="Notas legales"
            name="legalNotes"
          />
          <TextArea
            control={control}
            defaultValue={client?.observations}
            label="Descripción"
            name="observations"
          />
          {!client?.codeClient && (
            <Toggle
              control={control}
              name="codeClient"
              title="Asignar código de cliente"
            />
          )}
        </div>
        {denyRoles(['AUDITOR']) && (
          <div className="mt-3 flex justify-end gap-2">
            <Button
              color="slate-600"
              loading={isLoading}
              name="Actualizar"
              type="submit"
            />
          </div>
        )}
      </form>

      {barCode && (
        <Modal close={() => setBarCode(null)} state={!!barCode}>
          <div className="flex w-full flex-col items-center">
            <h5 className="font-mono">
              {client?.firstName ?? '' + ' ' + client?.lastName ?? ''}
            </h5>
            <Barcode value={barCode} />
          </div>
        </Modal>
      )}
    </>
  )
}

export default EditOnlinePersonalData
